export const selectUser = state => state.auth.user;
export const selectIsUserAuthenticated = state => state.auth.user !== null;
